var App = App || {};

App.ImageGallery = (function ($) {
    "use strict";

    function init() {

        const imageGallery = $(".block.block-imagegallery");
        if (imageGallery.length) {
            imageGallery.each(function () {
                InitCarousels($(this));
            });
        }
    }

    function InitCarousels(imageGallery) {
        const carousel = imageGallery.find(".splide");

        if (carousel.length) {
            const splideCarousel = new Splide(carousel[0], {
                pagination: false,
                gap: "60px",
                drag: true,
                snap: false,
                focus: 'center',
                trimSpace: false,
                perMove: 1,
                breakpoints: {
                    991: {
                        gap: "5px",
                    },
                }
            });

            splideCarousel.on('mounted', function () {
                var activeSlide = $(splideCarousel.Components.Elements.slides[0]);
                activeSlide.addClass("ZAG-active");
                imageGallery.find(".splide__slide").find("a, button").attr("tabindex", "-1");
                activeSlide.find("a, button").attr("tabindex", "0");

                //if image loads in late, adjust carousel height after it loads
                var activeSlideImage = activeSlide.find("img.imagegallery-item-image");
                if (activeSlideImage.length) {
                    activeSlideImage.one("load", function () {
                        updateCarouselHeight(imageGallery, carousel)
                    }).each(function () {
                        if (this.complete) {
                            $(this).trigger('load');
                        }
                    });
                } else {
                    updateCarouselHeight(imageGallery, carousel);
                }
            });

            splideCarousel.mount();

            splideCarousel.on('move', function () {
                imageGallery.find(".splide__slide.ZAG-active").removeClass("ZAG-active");
                var index = splideCarousel.Components.Controller.getIndex();
                $(splideCarousel.Components.Elements.slides[index]).addClass("ZAG-active");

                updateCarouselHeight(imageGallery, carousel);
            });

            splideCarousel.on('moved', function () {
                imageGallery.find(".splide__slide").attr("aria-hidden", true).find("a, button").attr("tabindex", "-1");
                imageGallery.find(".splide__slide.is-active").attr("aria-hidden", false).find("a, button").attr("tabindex", "0");
            });
        }
    }

    function updateCarouselHeight(imageGallery, carousel) {
        var newSlide = imageGallery.find(".splide__slide.ZAG-active .imagegallery-item");
        if (newSlide.length) {
            var newSlideHeight = newSlide.outerHeight() * 1.15;
            var newCarouselHeight = "calc(10rem + " + newSlideHeight + "px)"
            carousel.css("max-height", newCarouselHeight);
        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.ImageGallery.init();
});